import SelectedIconImage from '../../../../../src/assets/icons/tick-selected.svg'
import styled, { css } from 'styled-components'

export const UnitCardContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`

export const UnitDetails = styled.div`
    padding: 0.5rem 0;
    display: flex;
    justify-content: space-between;
    width: 100%;
    gap: 0.5rem;
`

export const UnitDetailsSubcontainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
`

export const FeaturesWrapper = styled.div`
    margin-top: 4px;
`

export const ImageContainer = styled.img`
    box-sizing: border-box;
    border-radius: 0.5rem;
    width: 4.5rem;
    height: 4.5rem;

    @media (min-width: 376px) {
        width: 25%;
        height: auto;
    }
`

export const SelectContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding-bottom: 0.5rem;
`

export const UnitTitle = styled.div(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-size: 1rem;
        line-height: 1.375rem;
        font-weight: 600;
        /* stylelint-disable value-no-vendor-prefix, property-no-vendor-prefix */
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        /* stylelint-enable value-no-vendor-prefix, property-no-vendor-prefix */
    `,
)

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
`

type SelectButtonProps = {
    isSelected: boolean
}

export const SelectButton = styled.div<SelectButtonProps>(
    ({ theme, isSelected }) => css`
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.25rem;
        padding: 0.25rem 0.5rem;
        border-radius: 0.5rem;
        ${isSelected &&
        css`
            background: ${theme.colors.tfwGrey};
        `}
        border: ${isSelected ? '2px' : '1px'} solid ${theme.colors.tfwBlack99};
        width: 40%;
        max-width: 18.5rem;

        @media (min-width: 320px) {
            min-width: 8.75rem;
        }

        @media (min-width: 375px) {
            min-width: 9.75rem;
        }
    `,
)

export const SelectedIcon = styled(SelectedIconImage)`
    width: 0.875rem;
    height: 0.875rem;
`

export const ButtonText = styled.span`
    display: block;
    padding: 0px 4px;
`

export const ViewMore = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    cursor: pointer;

    & > span {
        text-decoration-line: underline;
        text-decoration-style: dotted;
        text-decoration-thickness: 1px;
        text-underline-offset: 3px;
    }
`
